import { useAuth } from "@/context/AuthContext";
import { useSellerRef } from "@/context/SellerRefContext";
import { findSellerByCode, DEFAULT_SELLER_WHATSAPP } from "@/lib/sellers";

/**
 * Devuelve el WhatsApp y vendedor activo según prioridad:
 * 1) Cliente logueado → vendedor de su perfil
 * 2) Link personal (?vendedor=XX) → ese vendedor
 * 3) Default (Produlimp empresa)
 */
export const useActiveSeller = () => {
  const { user } = useAuth();
  const { seller: refSeller } = useSellerRef();

  if (user?.role === "customer" && user.seller_code) {
    const s = findSellerByCode(user.seller_code);
    if (s) return { seller: s, whatsapp: s.whatsapp, source: "profile" };
  }
  if (refSeller) {
    return { seller: refSeller, whatsapp: refSeller.whatsapp, source: "ref" };
  }
  return { seller: null, whatsapp: DEFAULT_SELLER_WHATSAPP, source: "default" };
};
